import { City } from '@prisma/client';
import axios from 'axios';

export async function createCity(data: Omit<City, 'id'>) {
  const response = await axios.post('/api/city', data);
  return response.data;
}

export async function updateCity(id: string, data: Partial<City>) {
  const response = await axios.patch(`/api/city/${id}`, data);
  return response.data;
}

export async function deleteCity(id: string) {
  const response = await axios.delete(`/api/city/${id}`);
  return response.data;
}
